<template>
  <div>
    <headerComponent />

    <div class="machineMain">
      <div class="banner">
        <div class="imgBox">
          <el-image
            :src="l.tu"
            style="width: 100%; display: block"
           v-for="(l,i) in bannerlie"></el-image>
        </div>
      </div>

      <div class="machineOne">
        <div class="w1300">
          <div class="box">
            <div class="tle txt-c"><h3 class="tit-40 fw700">系列选购</h3></div>

            <div class="con flex-sb">
              <div class="titlist">
                <ul>
                  <li
                    v-for="(item, index) in titlist"
                    :key="index"
                    :class="item.class"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
              <div class="itemlist">
                <ul>
					<li v-for="(s,i) in shangpinlie">
					  <div class="tit">{{s.ming}}</div>
					  <dl>
					    <dd>{{s.chicun}}</dd>
					    <dd>{{s.quanshenziyoudu}}</dd>
					    <dd>{{s.danbishenziyoudu}}</dd>
					    <dd>{{s.shuanbifuzai}}</dd>
					    <dd>{{s.danbibizhang}}</dd>
					    <dd>{{s.moduanzhixinqi}}</dd>
					    <dd>{{s.xuhanshijian}}</dd>
					    <dd>{{s.chongdianfanshi}}</dd>
					    <dd :class="l.ming=='/'?'zw':''" v-for="(l, idx) in  s.ganzhixitong">{{l.ming}}</dd>
					    <dd v-for="l in s.jiagoupeizhi">{{l.ming}}</dd>
					    <dd>{{s.suanli}}</dd>
					    <dd>{{s.sdkjjiekou}}</dd>
					    <dd>{{s.jiaohumoxing}}</dd>
					    <dd>{{s.vr}}</dd>
					    <dd>{{s.dipanyidong}}</dd>
					    <dd>{{s.zuixiaokongjian}}</dd>
					  </dl>
					  <div class="price">¥{{s.jiage}}</div>
					  <div class="more">
					    <router-link to="" class="a1">
							<div @click="addCart(s)" >加入购物车</div></router-link>
					    <router-link :to="{name: 'orderConfirm',params:{id:s.id,num:1}}" class="a2">立即购买</router-link>
					  </div>
					</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="machineTwo">
        <div class="w1300">
          <div class="tle txt-c">
            <h3 class="tit-40 fw700">{{shux.nei1.biaoti}}</h3>
          </div>
          <div class="box flex-sbw">
            <div class="imgBox">
                <!-- :src="require('@/assets/machine/machineTwo-img.jpg')" -->
              <el-image :src="shux.nei1.tu" ></el-image>
            </div>
            <div class="con flex-cc">
              <div class="info">
                <p>
                <!--  全尺寸等身机器人Wanda ，身高高达 168cm，拥有 33
                  个高自由度关节，可应对空间狭窄、任务复杂的多场景操作。 -->
				  {{shux.nei1.neirong1}}
                </p>
                <p>
					{{shux.nei1.neirong2}}
                  <!-- 全球首个 8 自由度仿人手臂，双臂峰值负载 12 KG，单臂臂展 982
                  mm，最高触达高度达 2300
                  mm，可完整覆盖人类上肢主要活动范围，实现高精度动作复现与多类型物体操作。 -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="machineThre">
        <div class="w1300">
          <div class="tle txt-c">
            <h3 class="tit-40 fw700">{{shux.nei2.biaoti}}</h3>
          </div>

          <dl class="flex-sbcw">
            <dd>
              <div class="icBox">
                <el-image
                  :src="require('@/assets/machine/machineThre-icon1.png')"
                ></el-image>
              </div>
              <div class="t1 tit-24 fw700">{{shux.nei2.biaoti2}}</div>
              <div class="p1 mt-10">
               {{shux.nei2.neirong1}}
              </div>
            </dd>
            <dd>
              <div class="icBox">
                <el-image
                  :src="require('@/assets/machine/machineThre-icon2.png')"
                ></el-image>
              </div>
              <div class="t1 tit-24 fw700">{{shux.nei2.biaoti3}}</div>
              <div class="p1 mt-10">
                {{shux.nei2.neirong2}}
              </div>
            </dd>
          </dl>
          <div class="imglist">
            <ul class="flex-sbcw">
              <li v-for="(item, index) in shux.nei2.xijietu" :key="index">
                <div class="imgBox">
                  <el-image :src="item"></el-image>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="machineFour">
        <div class="w1300">
          <div class="tle txt-c">
            <h3 class="tit-40 fw700">{{shux.nei3.biaoti}}</h3>
          </div>

          <div class="box flex">
            <div class="imgBox">
              <el-image
                :src="shux.nei3.tu"
              ></el-image>
            </div>
            <div class="con flex-c">
              <div class="info">
                <div class="item">
                  <div class="p1 tit-24 fw700">{{shux.nei3.biaoti2}}</div>
                  <div class="p2 tit-18 mt-10">
                    {{shux.nei3.neirong1}}
                  </div>
                </div>
                <div class="item">
                  <div class="p1 tit-24 fw700">{{shux.nei3.biaoti3}}</div>
                  <div class="p2 tit-18 mt-10">
                    {{shux.nei3.neirong2}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerComponent />
  </div>
</template>

<script>
// 引用头部组件
let that
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

export default {
  name: "MachineIndex",
  components: {
    headerComponent,
    footerComponent,
  },
	created(){
		that=this
		this.CSH()
		this.Qubanner()
	},
  data() {
    return {
      titlist: [
        { title: "/", class: "zw tit" },
        { title: "尺寸" },
        { title: "全身自由度" },
        { title: "单臂自由度" },
        { title: "双臂负载" },
        { title: "单臂臂展" },
        { title: "末端执行器" },
        { title: "续航时间" },
        { title: "充电方式" },
        { title: "感知系统" },
        { title: "/", class: "zw" },
        { title: "/", class: "zw" },
        { title: "/", class: "zw" },
        { title: "/", class: "zw" },
        { title: "/", class: "zw" },
        { title: "架构配置" },
        { title: "/", class: "zw" },
        { title: "算力" },
        { title: "SDK 接口" },
        { title: "交互大模型" },
        { title: "VR 遥操作系统" },
        { title: "底盘移动速度" },
        { title: "最小通过空间" },
      ],
	  shangpinlie:[],
	  bannerlie:[],
      // machineOnelist: [
      //   {
      //     title: "Wanda 2 Lite",
      //     value: [
      //       {
      //         title: "最高 1680 mmm",
      //       },
      //       {
      //         title: "23",
      //       },
      //       {
      //         title: "8",
      //       },
      //       {
      //         title: "4 kg",
      //       },
      //       {
      //         title: "982 mm",
      //       },
      //       {
      //         title: "夹爪",
      //       },
      //       {
      //         title: "6-8 h",
      //       },
      //       {
      //         title: "直充",
      //       },
      //       {
      //         title: "高清双目相机",
      //       },
      //       {
      //         title: "RGBD 摄像头",
      //       },
      //       {
      //         title: "360° 激光雷达",
      //       },
      //       {
      //         title: "红外传感器",
      //       },
      //       {
      //         title: "超声波传感器",
      //       },
      //       {
      //         title: "环形六麦",
      //       },
      //       {
      //         title: "NIVIDlA Jetson",
      //       },
      //       {
      //         title: "Orin NX 8 G",
      //       },
      //       {
      //         title: "70 Tops",
      //       },
      //       {
      //         title: "支持部分",
      //       },
      //       {
      //         title: "标配",
      //       },
      //       {
      //         title: "选配",
      //       },
      //       {
      //         title: "90 m/min",
      //       },
      //       {
      //         title: "75 cm",
      //       },
      //     ],
      //     price: "¥268,000",
      //     more: [
      //       {
      //         title: [
      //           {
      //             title: "加入购物车",
      //           },
      //           {
      //             title: "立即购买",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     title: "Wanda 2 Pro",
      //     value: "最高 1680 mmm",
      //   },
      //   {
      //     title: "Wanda 2 Pro",
      //     value: "最高 1680 mmm",
      //   },
      // ],

      machineThreImglist: [
        {
          imgUrl: require("@/assets/machine/machineThre-img1.jpg"),
        },
        {
          imgUrl: require("@/assets/machine/machineThre-img2.jpg"),
        },
        {
          imgUrl: require("@/assets/machine/machineThre-img3.jpg"),
        },
        {
          imgUrl: require("@/assets/machine/machineThre-img4.jpg"),
        },
        {
          imgUrl: require("@/assets/machine/machineThre-img5.jpg"),
        },
        {
          imgUrl: require("@/assets/machine/machineThre-img6.jpg"),
        },
      ],
	  shux:{}
    };
  },
  methods: {
	  CSH() {
	  	that.$post('k=shangpin',{ye:1,jitiao:3,fenlei:632}, function(s) {
	  		that.shangpinlie = s.shu.lie;
			that.shux=s.shu.xuanchuan
	  		// this.zongshu = Number(s.shu.zongshu);
	  	});
	  },
	  Qubanner(){
		  that.$post('k=company&c=Banner',{ye:1,jitiao:1,leixing:1}, function(s) {
			  that.bannerlie= s.shu.lie;
		  });
	  },
	  addCart(e){
		  var that=this
		  console.log(111)
		  console.log(e)
	  		  if(!this.$qu('yonghux')['kouling']){
	  			 this.$alert('Please log in first', '', {
	  			   confirmButtonText: 'Log in',
	  			   confirmButtonClass:'Loginanniu',
	  			   distinguishCancelAndClose:true,
	  			   center:true,
	  			   roundButton:true,
	  			   callback: action => {
	  			 	  if(action=='confirm'){
	  			 			that.$dakai('/login')
	  			 	  }
	  			   }
	  			 });
	  		  }else{
	  			  	if (!(e.kucun > 0)) {
	  			  		that.$xiaoxi('库存不足');
	  			  		return false;
	  			  	}
	  			  	console.log(that.$qu('hyid'))
	  			  	console.log(888)
	  			  	if(!that.$qu('hyid')){
	  			  		that.$xiaoxi('请先登录');
	  			  		setTimeout(function() {
	  			  			// uni.navigateTo({
	  			  			// 	url: '/pages/Denglu/index'
	  			  			// });
	  			  		}, 1000);
	  			  	}else{
	  				var canshu = 'ids=' +e.id + '&shuliang=' +1;			
					if (e.peisongfangshi) {
						canshu += '&peisongfangshi=' +e.peisongfangshi;
					}
					that.$post("m=limitao&k=gouwuche&c=tianjia&" + canshu, function(s) {
						that.$xiaoxi(s.shu);
					})					
	  				
	  			}
	  		  }
	  }
  }
};
</script>

<style lang="less" scoped>
.machineOne {
  padding: 0.75rem 0 1.2rem;
  .box {
    background: #f5f5f5;
    border-radius: 0.21rem;
    padding: 0.5rem;
    .con {
      margin-top: 0.5rem;
    }

    .titlist {
      padding: 0.5rem 0;

      li {
        margin: 0.1rem;
        color: #666666;
        font-size: var(--font18);
      }

      li.tit {
        font-size: var(--font30);
        font-family: Arial, Arial-Bold;
        font-weight: 700;
        color: #262b2e;
      }

      ul li.zw {
        opacity: 0;
      }
    }

    .itemlist {
      flex: 1;
      margin-left: 5%;
      overflow-x: auto;
      white-space: nowrap;
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0.3rem;
        justify-content: space-between;
      }
      li {
        text-align: center;
        padding: 0.5rem 0.3rem;
        border-radius: 0.2rem;
        background: #fff;

        .tit {
          font-size: var(--font30);
          font-family: Arial, Arial-Bold;
          font-weight: 700;
          color: #262b2e;
          padding-bottom: 0.1rem;
        }

        dd {
          margin: 0.1rem 0;
          color: #262b2e;
          font-size: var(--font18);
        }

        dd.zw {
          opacity: 0;
        }

        .price {
          font-size: var(--font28);
          font-weight: 700;
          font-family: Source Han Sans CN;
          color: #262b2e;
          margin-top: 0.4rem;
        }

        .more {
          margin-top: 0.3rem;
          font-size: var(--font15);
          display: grid;
          grid-template-columns: repeat(2, auto);
          gap: 0.1rem;
          justify-content: center;
          .a1 {
            border: 1px solid #000000;
            border-radius: 100px;
            padding: 0.08rem 0.15rem;
            color: #333333;
            transition: 0.5s;
            &:hover {
              color: #41b9e0;
              border-color: #41b9e0;
            }
          }
          .a2 {
            width: 1.06rem;
            min-width: 80px;
            color: #fff;
            padding: 0.08rem 0.15rem;
            background: linear-gradient(-14deg, #001ff5 0%, #41b9e0 100%);
            border-radius: 100px;
            transition: 0.5s;
            &:hover {
              background: linear-gradient(-14deg, #41b9e0 0%, #001ff5 100%);
            }
          }
        }
      }
    }
  }
}

.machineTwo {
  background: #f5f5f5;
  padding: 1rem 0;
  .box {
    margin-top: 0.7rem;
    background: #ffffff;
    .imgBox {
      width: 50%;
      .el-image {
        display: block;
        height: 100%;
      }
    }
    .con {
      width: 50%;
      padding: 0.2rem 0.6rem;
      p {
        margin: 0.3rem 0;
        font-size: var(--font18);
        line-height: 1.8;
      }
    }
  }
}

.machineThre {
  padding: 1rem 0;
  dl {
    margin-top: 0.6rem;

    dd {
      width: 48%;
      text-align: center;

      .icBox {
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-image {
          display: block;
          max-height: 100%;
        }
      }
      .t1 {
        margin-top: 0.15rem;
      }
      .p1 {
        color: #262b2e;
      }
    }
  }
  .imglist {
    margin-top: 0.6rem;

    li {
      max-width: 17%;
      .el-image {
        display: block;
        max-width: 100%;
      }
    }
  }
}

.machineFour {
  background: #f5f5f5;
  padding: 0.75rem 0 1rem;
  .box {
    margin-top: 0.6rem;
    background: #fff;

    .imgBox {
      width: 50%;
      .el-image {
        display: block;
        height: 100%;
      }
    }
    .con {
      width: 50%;
      padding: 0.2rem 0.6rem;

      .item {
        margin-bottom: 0.6rem;

        p {
          color: #262b2e;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
